// User-domain helpers. Home for anything that turns a user object into something
// for display (labels, initials, …).

type UserLike = {
    first_name?: string | null;
    last_name?: string | null;
};

// Display label for a user: "First Last". Returns '' when no name is set — callers
// decide their own fallback (e.g. '—', 'User').
export function userLabel(u: UserLike): string {
    return `${u.first_name ?? ''} ${u.last_name ?? ''}`.trim();
}
